<template>
  <div class="report-cards">
    <div
      class="report-card_item"
      v-for="(item, idx) in items"
      :key="item.name"
      :class="{ actived: checked.includes(idx) }"
      :style="{ 'border-color': getColor(idx) }"
      @click="change(idx)"
    >
      <div class="report-card_item-title">
        <div style="display: flex;align-items: center;">
          <span class="point" :style="{ background: getColor(idx) }"></span>
          <span :style="{ color: getColor(idx) }">{{ item.name }}</span>
        </div>
      </div>

      <div class="report-card_item-content">
        <div class="sum">
          <div class="row-title">
            合计 {{ item.total }}
          </div>

          <!-- <div class="row-value">
            {{ item.total }}
          </div> -->
        </div>

        <!-- <div class="date-count">
          <div class="row-title">
            {{ date }}
          </div>

          <div class="row-value border-value">
            <span :class="valueClass(item.count)">{{ item.count }}</span>
          </div>
        </div> -->
      </div>

      <div class="mask"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    insects: Array,
    date: String,
    colors: Array,
    checked: Array
  },
  computed: {
    items() {
      return this.insects.map(i => ({
        name: i.name,
        total: i.total,
        count: i.datasets[this.date]
      }))
    }
  },
  methods: {
    valueClass(v) {
      if (v >= 300) return 'danger'
      if (v >= 150) return 'warn'
      if (v >= 20) return 'pre-warn'
      return 'info'
    },
    getColor(idx) {
      return this.colors[idx % this.colors.length]
    },
    change(idx) {
      this.$emit('change', idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.report-cards {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  text-align: center;
  overflow-y: auto;
  border-bottom: 1px solid #c1c1c1;
}
.report-card_item {
  // flex: 1;
  // min-width: 120px;
  background-color: #fff;
  border-radius: 4px;
  margin-left: 8px;
  margin-bottom: 8px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 2px solid;
  flex: 0 0 auto;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  &.actived .mask {
    // background-color: #000;
    display: none;
  }
}
.report-card_item-title {
  border-bottom: 1px solid #f1f1f1;
  // padding: 10px 1rem;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-overflow: ellipsis;
  white-space: nowrap;
  .point {
    display: inline-block;
    color: #000;
    border-radius: 50%;
    height: 8px;
    width: 8px;
    margin-right: 8px;
  }
  user-select: none;
}
.report-card_item-content {
  display: flex;
  // padding: 12px;
  user-select: none;
  text-align: left;
  padding-right: 12px;
  padding-left: 22px;
  .sum {
    flex: 1;
  }
  .date-count {
    flex: 2;
  }
  .row-title {
    padding-bottom: 8px;
    color: #909399;
  }
  .row-value {
    // height: 32px;
    // line-height: 32px;
  }
  .border-value {
    span {
      padding: 0 12px;
      border: 1px solid #13ce66;
      color: #13ce66;
      text-shadow: 1px 1px 2px #f1f1f1;
    }
    .pre-warn {
      border: 1px solid #e6d23c;
      color: #e6d200;
      text-shadow: 1px 1px 1px #f1f1f1;
    }
    .warn {
      border: 1px solid #e6a23c;
      color: #e6a23c;
      text-shadow: 0 0 2px #f1f1f1;
    }
    .danger {
      border: 1px solid #f56c6c;
      color: #f56c6c;
      text-shadow: 0 0 2px #f1f1f1;
    }
  }
}
</style>
